import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const currentYear = new Date().getFullYear();

// 默认展示的机构ID
let defaultOrgIdEnum = {
    OrgId: 101,
    ComId: 122,
    HomeId: 69,
};

var store = new Vuex.Store({
    state: {
        // 
        defaultOrgIdEnum,
        // 最后四年
        lastFourYears: [currentYear, currentYear - 1, currentYear - 2, currentYear - 3],
        // 镇街列表
        townList: ['西樵镇', '桂城街道', '九江镇', '丹灶镇', '里水镇', '狮山镇', '大沥镇'],
        // 养老机构ID
        OrgId: defaultOrgIdEnum.OrgId,
        // 养老机构名字
        OrgName: "",
        // 幸福院ID
        ComId: defaultOrgIdEnum.ComId,
        // 幸福院名字
        ComName: "",
        // 服务商ID
        HomeId: defaultOrgIdEnum.HomeId,
        // 服务商名字
        HomeName: "",
        // 居家服务商特色服务的IframeUrl
        currentIframeUrl: '',
        // 视频的VideoUrl
        currentVideoUrl: '',
        // 图片的PictureUrl
        currentPictureUrl: '',
        // 当前镇街
        currentTown: '',
        // 当前机构
        currentOrganization: '',
        // 当前右侧的页码
        currentRightPage: 1,
        // 当前大屏中间展示的模块
        currentMiddleModule: null,
        // 当前整体模块
        currentModule: null,
        // 控制台的Websocket
        webSocket: null,
        webSocketStatus: false,
        webSocketInstructions: '',
        webSocketToken: '',
        kztSocketHeart: null,
        // 紧急呼叫的websocket
        mapWebSocket: null,
        mapSocketHeart: null,
        // 长者紧急呼叫信息
        currentEmergencyInfo: {},
        // 接口返回数据的缓存域
        requestData: {}
    },
    mutations: {
        setRequestData(state, object) {
            state.requestData[object['k']] = object['v'];
        },
        setCommonValue(state, datas) {
            if (Array.isArray(datas)) {
                for (let i = 0; i < datas.length; i++) {
                    state[datas[i]['k']] = datas[i]['v'];
                }
            } else {
                state[datas['k']] = datas['v'];
            }
        },
        setWebSocket(state, object) {
            state.webSocket = object;
        },
        setWebSocketInstructions(state, item) {
            state.webSocketInstructions = item;
        },
    }
});

export default store;